module.exports = __webpack_public_path__ + "img/ygbh_banner.0c1ebb05.png";